import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatTableModule } from '@angular/material/table'
import { MatTooltipModule } from '@angular/material/tooltip'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { ProductsSelectorModule } from '../products-selector'
import { ProceduresCardComponent } from './procedures-card.component'

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    FlexLayoutModule,
    MatCardModule,
    MatButtonModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatTableModule,
    ProductsSelectorModule,
    TranslateModule,
  ],
  declarations: [
    ProceduresCardComponent,
  ],
  exports: [ProceduresCardComponent],
})
export class ProceduresCardModule {}
